export function downloadBlob(blob: Blob, fileName: string, fileType: string) {
  const newBlob = new Blob([blob], { type: fileType });
  const url = URL.createObjectURL(newBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function findFrameInContainer(containerId: string) {
  const container = document.getElementById(containerId); // Get the container element
  if (container) {
    return container.querySelector('iframe');
  }
  return null;
}
